import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ToastService {

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }
  showError(content, title = '') {
    content = this.translate.instant(content);
    this.toastr.error(content, title);
  }
  showSuccess(content, title = '') {
    content = this.translate.instant(content);
    this.toastr.success(content, title);
  }
}
